import { Fragment, useMemo } from 'react';
import { Polygon } from 'react-leaflet';
import {
  HURRICANES_DEFAULT_REPLAY_MARKER_MODE,
  HURRICANES_STORM_MAP_PATH_OPTIONS,
} from '../../../../config/hurricanes.config';
import { getVisibleStormMapItems } from '../../../../utils/hurricaneMap.utils';
import StormPositionMarker from '../StormPositionMarker/StormPositionMarker';
import StormTrack from '../StormTrack/StormTrack';

// Renders every visible storm's cone/outline, full track path, and position
// markers. The track is always drawn in full; `frameIndex` (single-storm
// replay) only controls the markers — either one moving marker (`current`)
// or markers accumulating along the track (`trail`).
const HurricaneMapLayers = ({
  stormShapes = [],
  frameIndex = null,
  markerMode = HURRICANES_DEFAULT_REPLAY_MARKER_MODE,
}) => {
  const visibleStorms = useMemo(
    () => getVisibleStormMapItems(stormShapes, frameIndex, markerMode),
    [stormShapes, frameIndex, markerMode],
  );

  return (
    <>
      {visibleStorms.map(
        ({
          key,
          group,
          isAtTrackEnd,
          conePositions,
          outlinePositions,
          observedTrackPositions,
          forecastTrackPositions,
          markers,
        }) => (
          <Fragment key={key}>
            {isAtTrackEnd && conePositions && (
              <Polygon
                positions={conePositions}
                pathOptions={HURRICANES_STORM_MAP_PATH_OPTIONS.forecastCone}
              />
            )}
            {isAtTrackEnd && outlinePositions && (
              <Polygon
                positions={outlinePositions}
                pathOptions={HURRICANES_STORM_MAP_PATH_OPTIONS.historicalOutline}
              />
            )}
            <StormTrack
              positions={observedTrackPositions}
              casingPathOptions={HURRICANES_STORM_MAP_PATH_OPTIONS.observedTrackCasing}
              trackPathOptions={HURRICANES_STORM_MAP_PATH_OPTIONS.observedTrack}
            />
            <StormTrack
              positions={forecastTrackPositions}
              casingPathOptions={HURRICANES_STORM_MAP_PATH_OPTIONS.forecastTrackCasing}
              trackPathOptions={HURRICANES_STORM_MAP_PATH_OPTIONS.forecastTrack}
            />
            {markers.map((marker) => (
              <StormPositionMarker
                key={marker.key}
                group={group}
                marker={marker}
                isDefaultView={frameIndex === null}
              />
            ))}
          </Fragment>
        ),
      )}
    </>
  );
};

export default HurricaneMapLayers;
